<template>
  <div>
    <van-nav-bar title="重置密码" left-text="返回" left-arrow @click-left="topre">
      <template #right/>
    </van-nav-bar>
    <van-cell-group style="margin:10px 0px;">
      <van-field v-model="phone" style="border: #EEEEEE solid 1px;margin-bottom: 20px;" label="手机号" left-icon="user-o" placeholder="请输入手机号" />
      <van-field v-model="newPass" style="border: #EEEEEE solid 1px;" label="密码" input-align="left" left-icon="lock" type="password" placeholder="请输入新密码" />
    </van-cell-group>
    <van-field v-model="yzm" required clearable label="验证码" left-icon="comment-o" placeholder="验证码">
      <van-button slot="button" :disabled="codeDisabled" size="small" type="primary" @click="getCode">{{ codeMsg }}</van-button>
    </van-field>
    <van-button style="margin-top: 10px;" round block type="primary" size="large" @click="save">提交</van-button>

  </div>
</template>

<script>
import { Notify } from 'vant';
export default{
  name: 'Uppass', // 重置密码
  inject: ['reload'],
  data() {
    return {
      value: '',
      name: '',
      phone: '',
      newPass: '',
      tel: '',
      clientname: '',
      show: sessionStorage.getItem('show'),
      sms: '',
      idcard: '',
      yzm: '',
      mobile: '',
      checked: true,
      button: 'xl',
      disabled: false,
      codeDisabled: false,
      // 倒计时秒数
      countdown: 60,
      // 按钮上的文字
      codeMsg: '获取验证码',
      // 定时器
      timer: null,
      open_id: '',
      client_id: ''
    };
  },
  methods: {
    getCode() {
      // 验证码60秒倒计时
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.countdown > 0 && this.countdown <= 60) {
            this.countdown--;
            if (this.countdown !== 0) {
              this.codeMsg = '重新发送(' + this.countdown + ')';
              this.codeDisabled = true;
            } else {
              clearInterval(this.timer);
              this.codeMsg = '获取验证码';
              this.countdown = 60;
              this.timer = null;
              this.codeDisabled = false;
            }
            if (this.countdown == 59) {
              this.axios
                .post('/customer/staff/send-code', {
                  phone: this.phone,
                  cx_user: 'chunxue'
                })
                .then(res => {
                  if (res.data.success) {
                    Notify({
                      message: '已发送验证码到预留手机号',
                      duration: 1000,
                      background: '#1989fa'
                    });
                    this.mobile = res.data.mobile;
                    this.sms = '';
                  } else {
                    this.sms = res.data.msg;
                    clearInterval(this.timer);
                    this.codeMsg = '获取验证码';
                    this.countdown = 60;
                    this.timer = null;
                    this.codeDisabled = false;
                  }
                });
            }
          }
        }, 1000);
      }
    },
    save() {
      this.axios.post('/Reset/wxhr/password', {
        phone: this.phone,
        password: this.newPass,
        code: this.yzm,
        cx_user: 'chunxue'
      }).then(res => {
        if (res.data.success) {
          Notify({ type: 'success', message: res.data.msg });
          this.$router.push({ name: 'HrHome' });
        } else {
          Notify({ type: 'danger', message: res.data.msg });
        }
      });
    },
    topre() {
      sessionStorage.setItem('show', true);
      this.$router.go(-1);
      this.reload();
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/hr/uppass.vue